<div v-if="shouldRenderConfig" v-bind:class="getClassName">    
    <appProductPartsNamesContainer></appProductPartsNamesContainer>
    <div>
        <appProductParts></appProductParts>
        <appUploadContainer></appUploadContainer>
    </div>
    <div class="matrix_summaryInformation">
        <appSummaryTable></appSummaryTable>
        <appInformationTable></appInformationTable>
    </div>
</div>